import ReactDOM from 'react-dom'
// Axios
import axios from 'axios'
import {Chart, registerables} from 'chart.js'
import {QueryClient, QueryClientProvider} from 'react-query'

// Apps
import {MetronicI18nProvider} from './_metronic/i18n/Metronici18n'
/**
 * TIP: Replace this style import with dark styles to enable dark mode
 *
 * import './_metronic/assets/sass/style.dark.scss'
 *
 * TIP: Replace this style import with rtl styles to enable rtl mode
 *
 * import './_metronic/assets/css/style.rtl.css'
 **/
import './_metronic/assets/sass/style.react.scss'
import {AppRoutes} from './app/routing/AppRoutes'
import {AuthProvider, setupAxios} from './app/modules/auth'

const renderApp = () => {
  setupAxios(axios)
  Chart.register(...registerables)

  const queryClient = new QueryClient()

  ReactDOM.render(
    <QueryClientProvider client={queryClient}>
      <MetronicI18nProvider>
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </MetronicI18nProvider>
    </QueryClientProvider>,
    document.getElementById('root')
  )
}

const importStyles = async () => {
  try {
    const dir = localStorage.getItem('dir')

    if (dir === 'rtl') {
      await import('./_metronic/assets/css/style.rtl.css')
    } else {
      await import('./_metronic/assets/sass/style.scss')
    }

    renderApp()
  } catch (error) {
    console.error('Error importing styles:', error)
    // Render app anyway, even if styles fail to load
    renderApp()
  }
}
importStyles()
